import { Loader2, CheckCircle } from "lucide-react";

export default function PaymentProcessingLoader({
  visible,
}: {
  visible: boolean;
}) {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500">

      {/* Glass Card */}
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-8 w-[320px] text-center shadow-2xl border border-white/20">

        {/* Animated Spinner */}
        <div className="flex justify-center mb-6">
          <div className="relative">
            <Loader2 className="w-14 h-14 text-white animate-spin" />
            <div className="absolute inset-0 rounded-full blur-xl bg-white/30 animate-pulse"></div>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-white mb-2">
          Processing Payment
        </h2>

        {/* Subtitle */}
        <p className="text-white/80 text-sm">
          Please wait while we verify your payment...
        </p>

        {/* Animated dots */}
        <div className="flex justify-center gap-1 mt-4">
          <span className="w-2 h-2 bg-white rounded-full animate-bounce"></span>
          <span className="w-2 h-2 bg-white rounded-full animate-bounce delay-150"></span>
          <span className="w-2 h-2 bg-white rounded-full animate-bounce delay-300"></span>
        </div>
      </div>
    </div>
  );
}